import React from 'react';
import { Grid, Typography } from '@mui/material';
import Text from 'components/text';
import PerkCard from 'components/perk-card';
import { fontStyles } from 'styles/font-styles';
import { colors } from 'styles/colors';
import { useTranslation } from 'react-i18next';
import { perks } from './perks-data';

const PerksSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      flexDirection="column"
      sx={{ maxWidth: '842px', margin: { xs: '16px', md: '40px' } }}
    >
      <Typography sx={{ ...fontStyles.h3, color: colors.text.light.title }}>
        {t('Perks')}
      </Typography>
      <Text
        fontSize={18}
        lineHeight={1.5}
        color={colors.text.light.label}
        sx={{ marginTop: 1, marginBottom: 4 }}
      >
        {t('Exclusive perks through our partners')}
      </Text>

      <Grid container flexDirection="column" gap={3} sx={{ maxWidth: { md: '640px' } }}>
        {perks
          .filter((perk) => perk.active !== false)
          .map((perk) => (
            <PerkCard key={perk.id ?? perk.title} {...perk} />
          ))}
      </Grid>
    </Grid>
  );
};

export default PerksSection;
